











import {Component, Prop, Vue} from 'vue-property-decorator';
import ImageManager from '@/script/ImageManager';
import {Size} from '@/script/common';

export type PageType = 'Home' | 'Entrant';

@Component
export default class MenuItem extends Vue {
  @Prop({ type: String, required: true })
  private target!: PageType;

  @Prop({ type: Number, required: true })
  private sizeRatio!: number;

  private bgImage: string = '';

  private created() {
    this.bgImage = ImageManager.INSTANCE.get(this.target)!;
  }

  private get style() {
    const vHeight = this.sizeRatio * 170;
    const hHeight = (window.innerHeight - 90) / 4;

    const height = Math.min(vHeight, hHeight);
    const width = height * 3;

    return {
      '--image-url': `url(${this.bgImage})`,
      'width': `${width}px`,
      'minWidth': `${width}px`,
      'height': `${height}px`,
      'minHeight': `${height}px`,
    };
  }
}
